/**
 * i18n.js - Einfaches Internationalisierungs-System (ES Module)
 */

const translations = {
    de: {},
    en: {}
};

let currentLanguage = 'de';

async function loadTranslations(lang) {
    try {
        const response = await fetch(`/translations/${lang}.json`);
        if (response.ok) {
            const data = await response.json();
            translations[lang] = data;
            return true;
        }
        if (lang !== 'de') {
            return loadTranslations('de');
        }
        return false;
    } catch (error) {
        console.error(`Fehler beim Laden der Übersetzungen für ${lang}:`, error);
        return false;
    }
}

export async function initI18n() {
    const savedLanguage = localStorage.getItem('userLanguage') || 'de';
    currentLanguage = savedLanguage;
    await loadTranslations(currentLanguage);
    if (document.documentElement) {
        document.documentElement.lang = currentLanguage;
        document.documentElement.dir = currentLanguage === 'ar' ? 'rtl' : 'ltr';
    }
    window.dispatchEvent(new CustomEvent('languageChanged', { detail: { language: currentLanguage } }));
}

export async function setLanguage(lang) {
    if (!translations[lang] || Object.keys(translations[lang]).length === 0) {
        await loadTranslations(lang);
    }
    currentLanguage = lang;
    localStorage.setItem('userLanguage', lang);
    if (document.documentElement) {
        document.documentElement.lang = lang;
        document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
    }
    window.dispatchEvent(new CustomEvent('languageChanged', { detail: { language: lang } }));
    return true;
}

export function t(key, params = {}) {
    if (typeof params === 'string') {
        params = {};
    }
    const keys = key.split('.');
    let value = translations[currentLanguage];
    for (const k of keys) {
        if (value && typeof value === 'object' && k in value) {
            value = value[k];
        } else {
            if (currentLanguage !== 'de') {
                let fallbackValue = translations.de;
                for (const fk of keys) {
                    if (fallbackValue && typeof fallbackValue === 'object' && fk in fallbackValue) {
                        fallbackValue = fallbackValue[fk];
                    } else {
                        return key;
                    }
                }
                value = fallbackValue;
            } else {
                return key;
            }
            break;
        }
    }
    if (typeof value === 'string') {
        return value.replace(/\{(\w+)\}/g, (match, paramKey) => {
            return params[paramKey] !== undefined ? params[paramKey] : match;
        });
    }
    return value || key;
}

export function getCurrentLanguage() {
    return currentLanguage;
}

export function hasTranslation(key) {
    const keys = key.split('.');
    let value = translations[currentLanguage];
    for (const k of keys) {
        if (value && typeof value === 'object' && k in value) {
            value = value[k];
        } else {
            return false;
        }
    }
    return typeof value === 'string' && value.length > 0;
}

export const i18n = {
    get t() { return t; },
    setLanguage,
    getCurrentLanguage,
    hasTranslation,
    init: initI18n,
    translations,
    get currentLanguage() { return currentLanguage; },
    set currentLanguage(v) { currentLanguage = v; }
};

export default i18n;
